// Keep in sync with benchling/chemistry/schema/core/constants.py
export const COMPOUND_FIELD_DISPLAY_NAME = 'Compound';

export enum MoleculeSchemaInterfaceApiId {
  MOLECULE_COMPOUND_ID = 'ssi_moleculecompound',
  MOLECULE_FORM_ID = 'ssi_moleculeform',
}

export const MOLECULE_SCHEMA_INTERFACE_DISPLAY_NAMES: Record<MoleculeSchemaInterfaceApiId, string> = {
  [MoleculeSchemaInterfaceApiId.MOLECULE_COMPOUND_ID]: 'Molecule Compound',
  [MoleculeSchemaInterfaceApiId.MOLECULE_FORM_ID]: 'Molecule Form',
};

const MOLECULE_SCHEMA_INTERFACE_IDS: ReadonlyArray<string> = Object.values(MoleculeSchemaInterfaceApiId);

export function isMoleculeSchemaInterfaceId(id: string): id is MoleculeSchemaInterfaceApiId {
  return MOLECULE_SCHEMA_INTERFACE_IDS.includes(id);
}
